$.ajaxSetup({
  beforeSend(xhr) {
    if (!this.crossDomain) {
      xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    }
  },
});

// There's a vulnerability in jQuery where by default, it will eval any JS code
// returned with the correct contentType (application/js) set. We rely on this
// behavior in a few places (ajax_aware_redirect), and upgrading jQuery to a
// non-vuln version is more effort than its currently worth.
//
// So instead, let's make sure we don't eval JS on random websites, just our own.
// https://github.com/jquery/jquery/issues/2432
$.ajaxPrefilter((req) => {
  if (req.crossDomain) {
    req.contents.script = false;
  }
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/init/ajax_safety.js